import { gql } from '@apollo/client';

export default gql`
  mutation deleteMSGTemplate($_id: String) {
    deleteMSGTemplate(_id: $_id) {
      ok
      message
      error
    }
  }
`;
